import axiosInstance from "../axiosInstance";

export const postLikesApi = data => {
  return axiosInstance.post(`/api/likes`, data);
};

export const addCommentApi = data => {
  return axiosInstance.post(`/api/marks/comments`, data);
};

export const getCommentsApi = (id, page, per_page) => {
  return axiosInstance.get(
    `/api/marks/comments/${id}?page=${page}&per_page=${per_page}`
  );
};
